/* eslint-disable @angular-eslint/prefer-inject */
import { PurchaseOrderHeaderDataService } from '../infrastructure/purchase-order-headers/purchase-order-header.data.service';
import {
    PurchaseOrderHeaderCreate,
    PurchaseOrderHeaderDto,
    PurchaseOrderHeaderRead,
    PurchaseOrderHeaderSearchParams,
} from '../entities/purchase-order-header.dto';
import { PurchaseOrderHeaderStore } from '../infrastructure/purchase-order-headers/purchase-order-header.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { PurchaseOrderHeaderMapper } from '../infrastructure/purchase-order-headers/purchase-order-header.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes } from '@pf/shared-common';
import { map, Observable, tap } from 'rxjs';

@Injectable()
export class PurchaseOrderHeaderFacade extends AbstractManageEntityFacade<
    PurchaseOrderHeaderDto,
    PurchaseOrderHeaderRead,
    PurchaseOrderHeaderCreate,
    PurchaseOrderHeaderSearchParams
> {
    nameField: keyof PurchaseOrderHeaderDto = 'orderNumber';

    constructor(
        dataService: PurchaseOrderHeaderDataService,
        store: PurchaseOrderHeaderStore,
        mapper: PurchaseOrderHeaderMapper
    ) {
        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof PurchaseOrderHeaderDto, string>> {
        return { orderNumber: searchText };
    }

    getByOrderNumber$(
        orderNumber: string
    ): Observable<PurchaseOrderHeaderDto | null> {
        return this.oneTimeSearch$({
            pageIndex: 1,
            pageSize: 1,
            filters: {
                orderNumber,
            },
        }).pipe(
            map(result => result.data?.[0] ?? null),
            tap(po => {
                if (po) {
                    this.store.add(po, false);
                }
            })
        );
    }
}
